<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ vesselCode }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in globalSideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { VESSEL_SIDEMENU } from '@/store/types'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'vesselReview', text: 'Vessel' }
      ],
      newVessel: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      if (this.newVessel) {
        return 'New Vessel'
      } else {
        return 'Review Vessel'
      }
    },
    globalSideMenu() {
      return this.$store.state.vessel.sideMenu
    },
    vesselCode() {
      if (this.vesNo) {
        return this.vesNo
      } else {
        return 'New Vessel'
      }
    }
  },
  methods: {
    ...mapActions([
      'vesselInit'
    ]),
    async doInit() {
      if (!this.newVessel) {
        this.sideMenu.push({ name: 'vesselVoyageReview', text: 'Voyages' })
      }
      this.$store.commit(VESSEL_SIDEMENU, this.sideMenu)
    }
  },
  props: {
    vesNo: {
      type: String,
      default: ''
    }
  },
  beforeMount() {
    if (this.vesNo === 'New') {
      this.newVessel = true
    }
    // Manual breadcrumb
    this.breadcrumb = this.derieveBreadcrumbByName('vslDetVoy')
    this.breadcrumb.push({
      name: 'vesselReview',
      text: this.title
    })
  }
}
</script>

<style lang="scss">
</style>
